import React, { FC, HTMLProps } from 'react';
import { Link } from 'react-router-dom';
import styles from './nav_user_dropdown_link.module.scss';
import { Hyperlink } from '../../../components/Hyperlink';

export const NavUserDropdownLink: FC<{ to: string }> = ({ children, to }) => (
  <Link to={to} className={styles.container}>
    {children}
  </Link>
);

type Props = HTMLProps<HTMLAnchorElement> & { source?: string };
export const NavUserDropdownHyperlink: FC<Props> = ({ children, ...props }) => (
  <Hyperlink {...props} className={styles.container}>
    {children}
  </Hyperlink>
);
